import { useState } from 'react';
import { Link } from 'react-router-dom';

export default function Login() {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [showPassword, setShowPassword] = useState(false);

  const handleLogin = () => {
    // سيتم ربطه مع Supabase لاحقاً
    window.REACT_APP_NAVIGATE('/');
  };

  const handleGuestLogin = () => {
    // تسجيل الدخول كزائر
    window.REACT_APP_NAVIGATE('/');
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-blue-50 via-white to-purple-50 flex flex-col" dir="rtl">
      {/* Header */}
      <div className="px-4 py-6">
        <Link to="/" className="w-10 h-10 flex items-center justify-center">
          <i className="ri-arrow-right-line text-2xl text-gray-800"></i>
        </Link>
      </div>

      {/* Content */}
      <div className="flex-1 flex flex-col justify-center px-6 pb-20">
        {/* Logo */}
        <div className="text-center mb-8">
          <h1 className="text-4xl font-bold mb-2" style={{ fontFamily: '"Pacifico", serif' }}>logo</h1>
          <p className="text-gray-600">مرحباً بعودتك!</p>
        </div>

        {/* Form */}
        <div className="space-y-4 mb-6">
          <div>
            <input
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="البريد الإلكتروني"
              className="w-full px-4 py-4 bg-white rounded-2xl text-sm border border-gray-200 focus:outline-none focus:ring-2 focus:ring-blue-500"
            />
          </div>
          <div className="relative">
            <input
              type={showPassword ? 'text' : 'password'}
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              placeholder="كلمة المرور"
              className="w-full px-4 py-4 bg-white rounded-2xl text-sm border border-gray-200 focus:outline-none focus:ring-2 focus:ring-blue-500"
            />
            <button
              onClick={() => setShowPassword(!showPassword)}
              className="absolute left-4 top-1/2 -translate-y-1/2 text-gray-400"
            >
              <i className={`${showPassword ? 'ri-eye-off-line' : 'ri-eye-line'} text-xl`}></i>
            </button>
          </div>
          <div className="text-left">
            <Link to="/forgot-password" className="text-sm text-blue-600 hover:text-blue-700">
              نسيت كلمة المرور؟
            </Link>
          </div>
        </div>

        {/* Login Button */}
        <button
          onClick={handleLogin}
          className="w-full py-4 bg-gradient-to-r from-blue-500 to-purple-500 text-white rounded-2xl font-bold shadow-lg hover:shadow-xl transition-all duration-300 transform hover:scale-105 mb-4"
        >
          تسجيل الدخول
        </button>

        {/* Guest Login Button */}
        <button
          onClick={handleGuestLogin}
          className="w-full py-4 bg-white border-2 border-gray-200 text-gray-700 rounded-2xl font-bold hover:bg-gray-50 transition-all duration-300 mb-6"
        >
          <div className="flex items-center justify-center gap-2">
            <i className="ri-user-line text-xl"></i>
            <span>الدخول كزائر</span>
          </div>
        </button>

        {/* Divider */}
        <div className="flex items-center gap-4 mb-6">
          <div className="flex-1 h-px bg-gray-200"></div>
          <span className="text-sm text-gray-500">أو</span>
          <div className="flex-1 h-px bg-gray-200"></div>
        </div>

        {/* Social Login */}
        <div className="grid grid-cols-3 gap-4 mb-8">
          <button className="py-4 bg-white border border-gray-200 rounded-2xl hover:bg-gray-50 transition-colors flex items-center justify-center">
            <i className="ri-google-fill text-2xl text-red-500"></i>
          </button>
          <button className="py-4 bg-white border border-gray-200 rounded-2xl hover:bg-gray-50 transition-colors flex items-center justify-center">
            <i className="ri-facebook-fill text-2xl text-blue-600"></i>
          </button>
          <button className="py-4 bg-white border border-gray-200 rounded-2xl hover:bg-gray-50 transition-colors flex items-center justify-center">
            <i className="ri-apple-fill text-2xl text-gray-800"></i>
          </button>
        </div>

        {/* Register Link */}
        <p className="text-center text-gray-600">
          ليس لديك حساب؟{' '}
          <Link to="/register" className="text-blue-600 font-bold hover:text-blue-700">
            سجل الآن
          </Link>
        </p>
      </div>
    </div>
  );
}
